import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const archivedCarsApi = createApi({
  reducerPath: "archivedCarsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({  
    getAllArchivedCars: builder.query({
      query: () => ({
        url: "/Car/all-archived-cars",
        method: "GET",
      }),
    }),
 
    getAllCarsForOperationArchived: builder.query({
      query: () => ({
        url: "/Car/all-cars-for-operation-archived",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAllArchivedCarsQuery,
  useGetAllCarsForOperationArchivedQuery
} = archivedCarsApi;
